module.exports = __webpack_public_path__ + "static/media/hunterdoncentral.17994c27.png";